// Toast.js
import React from "react";

const Toast = ({ message, type, icon, onClose }) => {
  const toastObj = {
    error: "alert-error",
    warning: "alert-warning",
    info: "alert-info",
    success: "alert-success",
  };

  const toast = toastObj[type] ? toastObj[type] : "alert-info";

  return (
    <div
      role="alert"
      className={`alert ${toast} max-w-fit z-50 fixed bottom-4 right-4 text-white p-4 rounded-lg shadow-lg transition-opacity duration-300`}
      style={{ opacity: 1 }}
    >
      <div className="flex items-center justify-between gap-5">
        <div className="flex items-center ">
          {icon && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 shrink-0 stroke-current mr-2"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          )}
          <span>{message}</span>
        </div>

        <button onClick={onClose} className="text-white underline">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 shrink-0 stroke-current"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Toast;
